import { useState, useEffect } from 'react';
import apiClient from '../apiClient';

const useSourceOptions = () => {
  const [sourceOptions, setSourceOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSourceOptions = async () => {
      try {
        const response = await apiClient.get('/api/source');
        if (response.data && Array.isArray(response.data)) {
          setSourceOptions(response.data.map(item => item.source));
        }
      } catch (err) {
        setError(err);
        console.error('Failed to fetch Source options:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchSourceOptions();
  }, []);

  return { sourceOptions, loading, error };
};

export default useSourceOptions;
